export const colors = {
  transparent: "transparent",
  current: "currentColor",
  white: "#ffffff",
  black: "#000000",
  primary: {
    50: "#F3FBFA",
    100: "#B2E3DD",
    200: "#7ED2C7",
    300: "#45BFB0",
    400: "#00B19F",
    500: "#00A28D",
    default: "#00A28D",
    600: "#009480",
    700: "#009480",
    800: "#007461",
    900: "#007461",
  },
  neutral: {
    10: "#FAFAFB",
    20: "#F6F6F6",
    40: "#ECECED",
    60: "#DEDEE0",
    100: "#D0D0D3",
    200: "#B8B8BD",
    300: "#A0A0A7",
    400: "#898992",
    500: "#71717C",
    default: "#71717C",
    600: "#595966",
    700: "#414150",
    800: "#2A2A3A",
    850: "#1E1E2F",
    900: "#010613",
  },
  message: "#CAC4D0",
  secondary: "rgb(238, 238, 238, 0.65)",
  disabled: "rgb(238, 238, 238, 0.30)",
  placeholder: "#827D9D",
  error: "#EB5757",
  warn: "#FFC700",
  info: "#777E90",
  gradientDark:
    "linear-gradient(rgba(250, 250, 251, 0.16), rgba(250, 250, 251, 0.04))",
};

export default colors;
